export const FETCH_PICKUP_RATE_SUCCESS = 'FETCH_PICKUP_RATE_SUCCESS';
export const FETCH_PICKUP_RATE_REQUEST = 'FETCH_PICKUP_RATE_REQUEST';
export const FETCH_PICKUP_RATE_FAILURE = 'FETCH_PICKUP_RATE_FAILURE';
export const FETCH_PICKUP_RATE_REST = 'FETCH_PICKUP_RATE_REST';
export const fetchPickupRateSuccess = (payload) => ({
    type: FETCH_PICKUP_RATE_SUCCESS,
    payload,
});
export const fetchPickupRateRequest = (payload) => ({
    type: FETCH_PICKUP_RATE_REQUEST,
    payload,
});
export const fetchPickupRateFailure = (payload) => ({
    type: FETCH_PICKUP_RATE_FAILURE,
    payload,
});
export const fetchPickupRateRest = () => ({
    type: FETCH_PICKUP_RATE_REST,
});
